<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-toolbar dense dark>
        <v-toolbar-title>Meeting Tasks</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-flex>
    <v-layout row wrap justify-center>
      <v-flex xs11 my-1>
        <v-list dense>
          <v-list-tile
            v-for="item in TaskList"
            :key="item.ID"
            style="border-bottom: 1px solid lightgrey;"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{item.Name}}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-chip v-if="item.Complete" outline color="green" text-color="black" selected>
                <v-avatar class="green">C</v-avatar>Complete
              </v-chip>
              <v-chip v-else outline color="orange" text-color="black" selected>
                <v-avatar class="orange">P</v-avatar>Pending
              </v-chip>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: ["meetingID"],
  data() {
    return {
      TaskList: []
    };
  },
  watch: {
    meetingID(id) {
      if (id != -1) {
        this.fetchData();
      }
    }
  },
  methods: {
    fetchData() {
      let self = this;

      self.get(`MeetingTask/MeetingID?meetingID=${self.meetingID}`).then(r => {
        console.log(r.data);
        self.TaskList = r.data;
      });
    }
  }
};
</script>

<style>
</style>
